import { useTransition } from "react";
import useEvent from "react-use-event-hook";
import { useSetRecoilState } from "recoil";

import {
  liveMapAutofitPulseAtom,
  liveMapAutofitSuspendedAtom,
  scheduleAfterPaint,
} from "@ryde/shared";

export const useLiveMapAutofitBulkGate = () => {
  const [, startTransition] = useTransition();
  const setAutofitSuspended = useSetRecoilState(liveMapAutofitSuspendedAtom);
  const setAutofitPulse = useSetRecoilState(liveMapAutofitPulseAtom);

  const beginBulkAutofitSuspend = useEvent((): void => {
    setAutofitSuspended(true);
  });

  const endBulkAutofitSuspend = useEvent((): void => {
    queueMicrotask(() => {
      setAutofitSuspended(false);
      setAutofitPulse(count => count + 1);
    });
  });

  const runBulkSelectionDeferringMapRender = useEvent(
    (applySelection: () => void): void => {
      setAutofitSuspended(true);

      scheduleAfterPaint(() => {
        startTransition(() => {
          applySelection();

          scheduleAfterPaint(() => {
            queueMicrotask(() => {
              setAutofitSuspended(false);
              setAutofitPulse(count => count + 1);
            });
          });
        });
      });
    },
  );

  return {
    beginBulkAutofitSuspend,
    endBulkAutofitSuspend,
    runBulkSelectionDeferringMapRender,
  };
};
